module.exports = __webpack_public_path__ + "img/Livanorm_Gray_1280x1010.a814b4fd.jpg";